module.exports = __webpack_public_path__ + "static/media/li.24a0ca47.svg";